import ButtonV2, { getButtonClasses } from "components/elements/buttonV2"
import Image from "components/elements/image"
import TextLockupV2 from "components/elements/textLockupV2"
import { AnimatePresence, motion } from "framer-motion"
import PropTypes from "prop-types"
import React, { useState } from "react"
import Card from "./card"
import "./split-sticky-section-v2.scss"

const SplitStickySectionV2 = ({ cards, ctaButton, headingTitle, text }) => {
  const [currentImage, setCurrentImage] = useState(cards[0]?.image)

  const handleCardHover = image => {
    setCurrentImage(image)
  }

  const handleCardLeave = () => {
    setCurrentImage(cards[0]?.image)
  }

  return (
    <section className="split-sticky-section-v2">
      <div className="container-v2">
        {headingTitle.heading && (
          <div className="split-sticky-section-v2--header-wrapper">
            <h2>
              <TextLockupV2>{headingTitle.heading}</TextLockupV2>
            </h2>
            {/* Optional lead-in, used by the clinic pages */}
            {text && <p className="split-sticky-section-v2--text">{text}</p>}
          </div>
        )}

        <div className="split-sticky-section-v2--image-wrapper">
          {currentImage && currentImage?.fluid && (
            <div className="split-sticky-section-v2--image-container">
              <AnimatePresence mode="wait">
                <motion.div
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  initial={{ opacity: 0 }}
                  key={currentImage?.id || currentImage?.title}
                  style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    top: 0,
                    left: 0,
                  }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                >
                  <Image
                    alt={currentImage?.title}
                    className="location-section-v2--carousel-image"
                    image={currentImage?.fluid}
                  />
                </motion.div>
              </AnimatePresence>
            </div>
          )}

          {ctaButton && ctaButton.path && ctaButton.text && (
            <p className="split-sticky-section-v2--button under-image-button">
              <ButtonV2
                accessibilityLabel={ctaButton.accessibilityLabel}
                className={getButtonClasses(
                  ctaButton.buttonStyle || "primary-green",
                  ctaButton.buttonSize || "large"
                )}
                href={ctaButton.path}
                key={ctaButton.id}
                showArrow={ctaButton.showArrow === "Yes" ? true : false}
                text={ctaButton.text}
              />
            </p>
          )}
        </div>

        <div className="split-sticky-section-v2--cards">
          {cards?.length &&
            cards?.length > 0 &&
            cards.map(card => (
              <Card
                key={card.id}
                link={card?.url}
                onHover={() => handleCardHover(card.image)}
                onLeave={handleCardLeave}
                text={card?.text?.text}
                title={card.title}
              />
            ))}
        </div>
        {ctaButton && ctaButton?.path && ctaButton?.text && (
          <p className="split-sticky-section-v2--button bottom-button">
            <ButtonV2
              accessibilityLabel={ctaButton.accessibilityLabel}
              className={getButtonClasses(
                ctaButton.buttonStyle || "primary-green",
                ctaButton.buttonSize || "large"
              )}
              href={ctaButton.path}
              key={ctaButton.id}
              showArrow={ctaButton.showArrow === "Yes" ? true : false}
              text={ctaButton.text}
            />
          </p>
        )}
      </div>
    </section>
  )
}

SplitStickySectionV2.propTypes = {
  cards: PropTypes.array.isRequired,
  ctaButton: PropTypes.object.isRequired,
  headingTitle: PropTypes.string.isRequired,
  text: PropTypes.string,
}

export default SplitStickySectionV2
